import { useLocation } from 'react-router-dom';

const useFormattedPath = () => {
  const currentPath = useLocation().pathname;

  const pageName = currentPath
    .replace(/^\/d\//, '')
    .replace(/dimensions.*/, 'dimensions')
    .replace(/-/g, '_');
  return { pageName };
};

export default useFormattedPath;
